// src/services/hrm/adminAttendanceStats.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}admin/attendance/`;

export default {
  stats(params = {}) {
    return axios.get(`${API_URL}stats`, {
      params,
      headers: buildHeaders(),
    });
  },

  latestClockings(params = {}) {
    return axios.get(`${API_URL}latest-clockings`, {
      params,
      headers: buildHeaders(),
    });
  },
};
